// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_hero_sub1 = /** @type {(inputs: {}) => string} */ () => {
	return `Born in a Korean rice paddy. Perfected in Switzerland.`
};

const el_tech_hero_sub1 = /** @type {(inputs: {}) => string} */ () => {
	return `Γεννήθηκε σε ένα ορυζώνα της Κορέας. Τελειοποιήθηκε στην Ελβετία.`
};

const ru_tech_hero_sub1 = /** @type {(inputs: {}) => string} */ () => {
	return `Родилась на корейском рисовом поле. Усовершенствована в Швейцарии.`
};

const he_tech_hero_sub1 = /** @type {(inputs: {}) => string} */ () => {
	return `נולדה בשדה אורז קוריאני. הושלמה בשוויץ.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_hero_sub1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_hero_sub1(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_hero_sub1", locale)
	if (locale === "en") return en_tech_hero_sub1(inputs)
	if (locale === "el") return el_tech_hero_sub1(inputs)
	if (locale === "ru") return ru_tech_hero_sub1(inputs)
	if (locale === "he") return he_tech_hero_sub1(inputs)
	return "tech_hero_sub1"
};